module.exports = __webpack_public_path__ + "static/media/logo.765e6715.svg";